import { Pipe, PipeTransform } from '@angular/core';
import {
    PriceAmountValueBasicContentType,
    PriceEnvelopeInTicketType,
    PriceInTicketType,
} from "@afidium/ts-facade";

@Pipe({
    name: 'extractPriceBase'
})
export class ExtractPriceBasePipe implements PipeTransform {
    public transform(value: PriceInTicketType, type: string = 'cost'): {amount: number, currency: string} {

        if (!value || !value[type]) {
            return null;
        }

        const priceValue: PriceAmountValueBasicContentType =  (value[type] as PriceEnvelopeInTicketType)
            .detail?.base?.currencyArray[0];

        return priceValue ? {
            amount: Number(priceValue.amount),
            currency: priceValue.currencyCode
        }:
            null;
    }
}
